import { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import TextField from '@mui/material/TextField';

import classes from './CoevaluationComment.module.css';

const CoevaluationComment = props => {
  const { t } = useTranslation(['lesson']);
  const [comment, setComment] = useState();

  const handleChange = event => {
    setComment(event.target.value);
    props.coevaluationCommentHandler(event.target.value);
  };

  return (
    <>
      <p className={classes.commentInfo}>
        {t('send_feedback_text')}
      </p>
      <TextField
        required
        className={classes.commentInput}
        onChange={handleChange}
        label={t('comment')}
        value={comment}
      />
    </>
  );
};

CoevaluationComment.propTypes = {
  // eslint-disable-next-line react/require-default-props
  coevaluationCommentHandler: PropTypes.func
};

export default CoevaluationComment;
